// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".heat-content[data-v-4fc0698d]{height:100vh;width:100vw;background-color:#fff}.heat-search[data-v-4fc0698d]{position:fixed;right:0;top:50px;z-index:999}", ""]);
// Exports
module.exports = exports;
